import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class SaveConfigurationService {

  private readonly saveConfigurationUrl: string = 'action/backup/armDB';
  FileSaver;

  constructor(private http: HttpClient) {
    this.FileSaver = require('file-saver');
  }

  public saveConfiguration(): void {
    this.http.get(this.saveConfigurationUrl, { responseType: 'blob' }).subscribe(data => {
      const fileType = {type: 'application/zip'};
      const blob = new Blob([ data ], fileType);

      this.FileSaver.saveAs(blob, 'ARM_Configuration.zip');
    });
  }
}
